import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import type { DimensionRow } from "../api/client";

const formatter = new Intl.NumberFormat("zh-HK");
const percentageFormatter = new Intl.NumberFormat("zh-HK", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1
});

function formatPercentage(value: number): string {
  return `${percentageFormatter.format(value)}%`;
}

export function ReferrersPage({
  title,
  rows,
  formatName = (name) => name
}: {
  title: string;
  rows: DimensionRow[];
  formatName?: (name: string) => string;
}) {
  const displayRows = rows.map((row) => ({ ...row, displayName: formatName(row.name) }));

  return (
    <div className="page-stack">
      <div className="toolbar-row">
        <h2>{title}</h2>
      </div>
      <section className="panel">
        <ResponsiveContainer width="100%" height={340}>
          <BarChart data={displayRows.slice(0, 12)} layout="vertical" margin={{ left: 32 }}>
            <CartesianGrid stroke="#e5e7eb" />
            <XAxis type="number" />
            <YAxis dataKey="displayName" type="category" width={150} />
            <Tooltip />
            <Bar dataKey="views" name="觀看" fill="#1c2676" />
          </BarChart>
        </ResponsiveContainer>
      </section>
      <section className="panel">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>項目</th>
                <th>觀看</th>
                <th>佔比</th>
              </tr>
            </thead>
            <tbody>
              {displayRows.map((row) => (
                <tr key={row.name}>
                  <td>{row.displayName}</td>
                  <td>{formatter.format(row.views)}</td>
                  <td>{formatPercentage(row.percentage)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
